import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "p-form-count" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ButtonCount = _resolveComponent("ButtonCount")!
  const _component_InputNumber = _resolveComponent("InputNumber")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_ButtonCount, {
      type: "button",
      kind: "minus",
      disabled: _ctx.minusButtonDisabled,
      class: "p-form-count__button",
      onClickButton: _cache[0] || (_cache[0] = ($event: any) => (_ctx.changeCount(-1)))
    }, null, 8, ["disabled"]),
    _createVNode(_component_InputNumber, {
      modelValue: _ctx.count,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.count) = $event)),
      id: _ctx.id,
      name: _ctx.name,
      class: "p-form-count__input",
      step: 1,
      min: _ctx.min,
      max: _ctx.max,
      ref: "input"
    }, null, 8, ["modelValue", "id", "name", "min", "max"]),
    _createVNode(_component_ButtonCount, {
      type: "button",
      kind: "plus",
      disabled: _ctx.plusButtonDisabled,
      class: "p-form-count__button",
      onClickButton: _cache[2] || (_cache[2] = ($event: any) => (_ctx.changeCount(1)))
    }, null, 8, ["disabled"])
  ]))
}